import useUserStore from "@/stores/user.store";
import AppRoutes from "@/constants/routes/AppRoutes";
import { User } from "@/models/users/User";

export type FinalizeLoginOptions = {
  me?: User;
  tenantId?: string;
  updateContext: (context: {
    userId: string;
    properties: { tenantId?: string };
  }) => void;
  onLogin?: () => void;
  setIsLoggedInOnce?: (v: boolean) => void;
  navigate: (path: string) => void;
  returnTo?: string;
};

/** Pathname segment of a same-origin path or absolute URL string. */
function pathnameOnly(pathOrUrl: string): string {
  try {
    return new URL(pathOrUrl, window.location.origin).pathname;
  } catch {
    const noHash = pathOrUrl.split("#")[0] ?? pathOrUrl;
    return noHash.split("?")[0] ?? pathOrUrl;
  }
}

/**
 * Plain `/auth` would loop after login; `/auth?...organization_switched...` must still be reachable for org-picker return.
 */
function shouldRedirectAwayFromAuthReturn(returnTo: string): boolean {
  if (pathnameOnly(returnTo) !== AppRoutes.auth) return false;
  return !returnTo.includes("organization_switched");
}

export function finalizeLogin({
  me,
  tenantId,
  updateContext,
  onLogin,
  setIsLoggedInOnce,
  navigate,
  returnTo,
}: FinalizeLoginOptions) {
  localStorage.setItem("onboarded", "true");

  if (me) {
    useUserStore.setState({ me });
    updateContext({
      userId: me.id,
      properties: {
        tenantId,
      },
    });
  }

  if (onLogin) onLogin();
  if (setIsLoggedInOnce) setIsLoggedInOnce(true);

  const destination =
    returnTo &&
    returnTo !== "/" &&
    !shouldRedirectAwayFromAuthReturn(returnTo)
      ? returnTo
      : AppRoutes.dashboard;

  navigate(destination);
}
